import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, useAuth } from "@/App";
import { Button } from "@/components/ui/button";
import { Eye, Send, ArrowLeft } from "lucide-react";

export const DraftPreviewBar = ({ post, onPublished }) => {
  const { token } = useAuth();
  const [publishing, setPublishing] = useState(false);

  const publish = async () => {
    if (!window.confirm(`Publish "${post.title}" now? It will appear on the blog immediately.`)) return;
    setPublishing(true);
    try {
      const { id, created_at, updated_at, ...data } = post;
      await axios.put(`${API}/admin/blog/${id}`, { ...data, published: true }, { headers: { Authorization: `Bearer ${token}` } });
      toast.success("Post published");
      onPublished();
    } catch (error) {
      toast.error("Failed to publish");
    } finally {
      setPublishing(false);
    }
  };

  return (
    <div data-testid="draft-preview-bar" className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[80] flex items-center gap-3 px-4 py-2.5 rounded-full bg-charcoal/95 text-ivory shadow-2xl backdrop-blur-md border border-ivory/10">
      <span className="flex items-center gap-2 font-body text-xs tracking-widest uppercase text-champagne-gold pr-2 border-r border-ivory/15">
        <Eye className="w-3.5 h-3.5" /> Preview
      </span>
      <span data-testid="draft-preview-status" className="font-body text-xs text-ivory/80 whitespace-nowrap">
        {post.published ? "This post is live — showing the latest saved version" : "Draft — only you can see this page"}
      </span>
      <Button size="sm" variant="ghost" asChild className="text-ivory/80 hover:text-ivory hover:bg-white/10 h-8">
        <a href="/admin/blog" data-testid="draft-preview-back-btn"><ArrowLeft className="w-3.5 h-3.5 mr-1" /> Back to posts</a>
      </Button>
      {!post.published && (
        <Button size="sm" className="bg-champagne-gold text-charcoal hover:bg-champagne h-8 rounded-full px-4" disabled={publishing} onClick={publish} data-testid="draft-preview-publish-btn">
          <Send className="w-3.5 h-3.5 mr-1" /> {publishing ? "Publishing..." : "Publish now"}
        </Button>
      )}
    </div>
  );
};
